<template>
  <div class="block">
    <!-- table actions -->
    <div class="px-5 py-5">
      <!-- top search bar -->
      <div class="d-flex">
        <div class="form-input-group flex-grow-1 mr-5">
          <div class="prepend-icon" style="top: 45%;">
            <v-icon>search</v-icon>
          </div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <button class="btn btn-primary w-88px" @click="getShareholderMeetings">搜尋</button>
      </div>
    </div>

    <!-- table -->
    <div class="table">
      <div class="table-head">
        <!-- column head -->
        <div class="form-item d-flex px-5 h-60px align-center">
          <h5 class="col-icon"></h5>
          <h5 class="col-year">年份</h5>
          <h5 class="col-date">日期</h5>
          <h5 class="col-subject">主旨</h5>
          <h5 class="col-icon ml-auto">編輯</h5>
          <h5 class="col-icon">刪除</h5>
        </div>
      </div>
      <div class="table-body">
        <TableCollapse v-for="item in shareholderMeetings" :key="item.id">
          <!-- row 1 -->
          <template v-slot:head="slotProps">
            <div class="form-item d-flex h-60px align-center">
              <div class="h5 col-icon">
                <v-icon color="ink-01-emphasis" v-if="!slotProps.isBodyShow"
                  >unfold_more</v-icon
                >
                <v-icon color="ink-01-emphasis" v-if="slotProps.isBodyShow"
                  >unfold_less</v-icon
                >
              </div>
              <div class="h5 col-year">{{ stampToYear(item.event_date) }}</div>
              <div class="h5 col-date">{{ stampToDate(item.event_date) }}</div>
              <div class="h5 col-subject">{{ item.title }}</div>
              <div class="h5 col-icon ml-auto">
                <button class="btn square" @click.stop="editItem(item.id)">
                  <v-icon>edit</v-icon>
                </button>
              </div>
              <h5 class="col-icon">
                <deleteDialog
                  @confirm-delete="deleteItem(item.id)"
                ></deleteDialog>
              </h5>
            </div>
          </template>
          <!-- row 2 -->
          <template v-slot:body>
            <div class="form-item py-5" style="font-size: 14px;">
              <!-- 年份 -->
              <div class="d-flex pa-10px highlight-at-oddline">
                <h5 class="w-120px mr-10px">年份</h5>
                <div class="flex-grow-1 flex-basis-0">
                  {{ stampToYear(item.event_date) }}
                </div>
              </div>
              <!-- 日期 -->
              <div class="d-flex pa-10px highlight-at-oddline">
                <h5 class="w-120px mr-10px">日期</h5>
                <div class="flex-grow-1 flex-basis-0">
                  {{ stampToDate(item.event_date) }}
                </div>
              </div>
              <!-- 主旨 -->
              <div class="d-flex pa-10px highlight-at-oddline">
                <h5 class="w-120px mr-10px">主旨</h5>
                <div class="flex-grow-1 flex-basis-0">
                  {{ item.title }}
                </div>
              </div>
              <!-- files -->
              <div
                class="d-flex pa-10px highlight-at-oddline"
                v-for="(file, j) in item.downloads"
                :key="j"
              >
                <h5 class="w-120px mr-10px">file {{ j + 1 }}</h5>
                <div class="flex-grow-1 flex-basis-0">
                  <a :href="file.file" class="text-decoration-none" target="_blank">
                    {{ file.title }}
                  </a>
                </div>
              </div>
            </div>
          </template>
        </TableCollapse>
      </div>
    </div>

    <!-- table footer -->
    <Pagination @handleNextPreEvent="getShareholderMeetings" model="shareholderMeeting">
    </Pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TableCollapse from '@/components/TableCollapse.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  components: {
    TableCollapse,
    deleteDialog,
    Pagination,
  },
  computed: {
    ...mapState('shareholderMeeting', ['shareholderMeetings', 'filter']),
  },
  methods: {
    ...mapActions('shareholderMeeting', {
      getShareholderMeetings: 'find',
      destroyShareholderMeeting: 'destroy',
      clear: 'clear',
    }),
    editItem(id) {
      this.$router.push({
        name: 'ShareholderMeetingEdit',
        params: { id },
      });
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyShareholderMeeting(id).then(() => {
        this.getShareholderMeetings();
      });
    },
    stampToDate(stamp) {
      const dateObj = new Date(stamp);
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const date = String(dateObj.getDate()).padStart(2, '0');

      return `${month}月${date}日`;
    },
    stampToYear(stamp) {
      const dateObj = new Date(stamp);
      const year = dateObj.getFullYear();

      return `${year}年`;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-year {
    width: 50px;
    margin-right: 40px;
  }
  .col-date {
    width: 60px;
    margin-right: 40px;
  }
  .highlight-at-oddline:nth-of-type(2n + 1) {
    background-color: $gray-100;
  }
}
</style>
